import { Component, inject, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import { BaseComponent, NotificationInstance } from '../shared'
import { DeviceNotificationService } from '../shared/services/device-notification-service'
import { HomeNotificationsComponent } from './notifications/notifications.component'
import { UserMetricsComponent } from './user-metrics/user-metrics.component'
import { UserRocksComponent } from './user-rocks/user-rocks.component'
import { UserToDosComponent } from './user-to-dos/user-to-dos.component'

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: true,
    imports: [HomeNotificationsComponent, UserToDosComponent, UserRocksComponent, UserMetricsComponent],
})
export class HomeComponent extends BaseComponent {
    deviceNotificationService = inject(DeviceNotificationService)
    activatedRoute = inject(ActivatedRoute)

    faSearch = faSearch
    notificationId?: string
    notifications: NotificationInstance[] = []
    selectedNotification: NotificationInstance | null = null

    showRequestButton = signal(false)
    showDuckDuckGoAlert = signal(true)

    /**
     * Check if the user is using DuckDuckGo browser which doesn't support notifications
     */
    isDuckDuckGo(): boolean {
        return !!(window as any).navigator?.duckduckgo
    }

    /**
     * Check if the DuckDuckGo alert should be shown (not dismissed)
     */
    shouldShowDuckDuckGoAlert(): boolean {
        return this.isDuckDuckGo() && this.showDuckDuckGoAlert()
    }

    /**
     * Dismiss the DuckDuckGo alert and remember the choice
     */
    dismissDuckDuckGoAlert(): void {
        this.showDuckDuckGoAlert.set(false)
        localStorage.setItem('duckduckgo-alert-dismissed', 'true')
    }

    constructor() {
        super()

        const notificationId = this.services.angular.getQueryParam('notificationId', this.activatedRoute)
        if (notificationId) {
            this.notificationId = notificationId
        }

        // Check if DuckDuckGo alert was previously dismissed
        const alertDismissed = localStorage.getItem('duckduckgo-alert-dismissed')
        if (alertDismissed === 'true') {
            this.showDuckDuckGoAlert.set(false)
        }

        // When the app is first asking for permissions there is some delay, and we don't want to show the button.
        setTimeout(() => {
            this.showRequestButton.set(true)
        }, 2000)
    }

    /**
     *  This method is called when the user clicks on the Request Notifications button.
     *  A user initiated action is required by iOS to show the notification permission dialog.
     */
    requestNotifications() {
        if (this.isDuckDuckGo()) return

        this.deviceNotificationService.requestPermission()
        this.deviceNotificationService.showInstructions.set(true)
    }
}
